import React, { useEffect } from "react";
import ViewContactForm from "./ViewContactForm";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import { useTranslation } from "react-i18next";
import { GridStack } from "gridstack";
import DMSHeader from "../../DMSHeader/DMSHeader";

// Main Component for viewing contact details
const ViewContactMain = () => {
  const { t } = useTranslation(); // Initialize translation hook

  // Initialize GridStack
  useEffect(() => {
    GridStack.init();
  }, []);

  // Layout configuration for grid items with header and contact view form
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 0,
      // Header component with title, download and menu options
      component: (
        <DMSHeader
          title={t("View Contact Details")}
          fileName=""
          showmenu={true}
          showdownload={false}
          showIconsForback={true}
          showImportDropDownLabel={false}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 12,
      id: 1,
      component: <ViewContactForm />,
    },
  ];
  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition ">
      <GridItem layoutData={layoutData} /> {/* Render grid-based layout */}
    </div>
  );
};
export default ViewContactMain;
